import FormInputStatus from "../../utils/enumerations/FormInputStatus";
import HtmlTagName from "../../utils/stringLiterals/HtmlTagName";
import TargetApiUrlAndPath from "../../utils/webApi/TargetApiUrlAndPath"
import HttpRequestService from "../../serviceLayer/httpProtocol/HttpRequestService";
import ValidationService from "../../serviceLayer/validators/ValidationService";
import UserCreator from "../objectCreator/UserCreator";

const processCreateUserInputValidation = function(userObj){
    const formInputStatusRequired = FormInputStatus[FormInputStatus.Required];

    const usernameErrorsReport = ValidationService.validateInput(HtmlTagName.USERNAME, formInputStatusRequired, userObj.username);
    const emailErrorsReport = ValidationService.validateInput(HtmlTagName.EMAIL, formInputStatusRequired , userObj.email);
    const passwordErrorsReport = ValidationService.validateInput(HtmlTagName.PASSWORD, formInputStatusRequired, userObj.password);

    const completeErrorsReport = Object.assign({}, usernameErrorsReport, 
                                                   emailErrorsReport,
                                                   passwordErrorsReport                                         
                                                );
    return completeErrorsReport;
}

const processUpdatePasswordInputValidation = function(password, confirmPassword){
     const formInputStatusRequired = FormInputStatus[FormInputStatus.Required];
    const passwordErrorsReport = ValidationService.validateInput(HtmlTagName.PASSWORD, formInputStatusRequired, password);
    const confirmPasswordErrorsReport = ValidationService.validateInput(HtmlTagName.CONFIRMPASSWORD, formInputStatusRequired , confirmPassword);
    
    const inputObj = UserCreator.createPasswordComparer(password, confirmPassword);
    const comparisonReport = ValidationService.compareInputsAreEqual(inputObj);

    const completeErrorsReport = Object.assign({}, passwordErrorsReport, 
                                                   confirmPasswordErrorsReport,
                                                   comparisonReport);
    return completeErrorsReport;
}


const processHttpRequestCreateUser = function(userObj, createUserPageCallback){
    const url = HttpRequestService.getUrl( TargetApiUrlAndPath.API_AUTH_REGISTER_PATH );
    const payload = userObj;

    HttpRequestService.POSTMethod(url, payload, (httpResponse)=>{
        createUserPageCallback(httpResponse);        
    });
};

const processHttpRequestUpdatePassword = function(password, confirmPassword, updatePasswordPageCallback){
    const url = HttpRequestService.getUrl( TargetApiUrlAndPath.API_UPDATE_PASSWORD_CREDENTIALS );
    const payload = { password : password, confirmPassword : confirmPassword };

    HttpRequestService.PUTMethod(url, payload, (httpResponse)=>{
        updatePasswordPageCallback(httpResponse);        
    });
};

const UserHelper = Object.freeze({
    processCreateUserInputValidation : processCreateUserInputValidation,
    processUpdatePasswordInputValidation : processUpdatePasswordInputValidation,
    processHttpRequestCreateUser : processHttpRequestCreateUser,
    processHttpRequestUpdatePassword : processHttpRequestUpdatePassword
});

export default UserHelper;
